<!--
 @description tab导航视图
 @author xiehan
 @date 2018/9/19
-->
<style>
.tabView {
  position: absolute;
  left: 0;
  right: 0;
  top: 41px;
  bottom: 0;
  padding: 16px;
  border: 1px rgba(0, 0, 0, 0.09) solid;
  background: #FFF;
  border-top: 0px;
  box-shadow: 3px 3px 5px #ddd;
  overflow-y: auto;
}
</style>
<template>
  <div class="tabView">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'appMain'
  }
</script>
